'use strict';

var _ = require('../mindash');

module.exports = {
  getItem: _.noop,
  setItem: _.noop
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/noopStorage.js
 ** module id = 139
 ** module chunks = 0
 **/